//@ts-ignore
import Swiper, { Pagination } from 'swiper';
Swiper.use([ Pagination ]);


export namespace PreviewCard {
	let setupPreviewCard = () => {

        let previewCards = document.querySelectorAll('.js-preview-card');
        let isSmallScreen = window.matchMedia("(max-width: 992px)").matches;

        previewCards.forEach(function(previewCard, index) {

            // get our initial values
            let activeSlide = 0;
            let numberOfSlides = 0;
            let centerSlides = false;
            let previewCardWrapper = previewCard.closest('.preview-card__wrapper');
            let swiperWrapper = previewCardWrapper.querySelector('.swiper-wrapper');
            let previewCardList = [];
            if (swiperWrapper){
                numberOfSlides = swiperWrapper.childElementCount;
            }

            // only initialize if slide > 1
            if ( numberOfSlides > 1 ){
                // add classes with indexes to handle multiple sliders
                previewCard.classList.add('preview-card-' + index);
                previewCardWrapper.classList.add('preview-card__wrapper-' + index);

                // logic for centering active slide
                // if viewport is < 992 and number of slides is greater than 2 --> center
                // if number of slides > 4 --> center
                // otherwise, don't center
                if ( numberOfSlides > 2 && isSmallScreen === true ) {
                    centerSlides = true;
                    activeSlide = 1;
                } else if ( numberOfSlides > 4 ){
                    centerSlides = true;
                    activeSlide = 2;
                } else {
                    activeSlide = 0;
                    centerSlides = false;
                }

                // configure our slider
                let previewCardSlider = new Swiper('.preview-card-' + index, {
                    speed: 400,
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                    centeredSlides: centerSlides,
                    centerInsufficientSlides: true,
                    initialSlide: activeSlide,
                    simulateTouch: true,
                    watchOverflow: true,
                    pagination: {
                        el: ".js-preview-card-pagination",
                        clickable: true
                    }
                });

                previewCardList.push(previewCardSlider);
                previewCardSlider.init();
            }
        });
	}

	export const init = () => {
		setupPreviewCard();
	}
}
